// --- GSAP等の設定 ----
// GSAP
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);




document.addEventListener('DOMContentLoaded', function (event) {

  // 全ページでスクロールしたらヘッダースタイルを切り替える
  const header = document.querySelector('.l-header');
  ScrollTrigger.create({
    start: "top -100",
    onEnter: () => {
      header.classList.add('scrolling');
    },
    onLeaveBack: () => {
      header.classList.remove('scrolling');
    }
  });

  // --- scrollEffect ---
  if (document.querySelector('.js-slideup')) {
    document.querySelectorAll('.js-slideup').forEach(elm => {

      ScrollTrigger.create({
        toggleActions: 'play pause resume reset',
        trigger: elm,
        start: `top bottom`,
        onEnter: function () {
          elm.classList.remove('init');
        },
        onLeaveBack: function () {
          elm.classList.add('init');
        },
      });
    });
  }

  // --- scrollEffect(Title) ---
  if (document.querySelector('.js-title-slideup')) {
    document.querySelectorAll('.js-title-slideup').forEach(elm => {

      const lines = elm.innerHTML
        .replace(/<br\s*\/?>/g, '\n')
        .split('\n');
      let html = '';

      lines.forEach((line, lineIndex) => {
        const chars = splitHTML(line);

        let lineHtml = '';

        for (let char of chars) {
          if (char === ' ') {
            lineHtml += '&nbsp;';
          } else if (char.startsWith('&') && char.endsWith(';')) {
            lineHtml += `<span class="--char">${char}</span>`;
          } else if ([...char].length === 1) {
            lineHtml += `<span class="--char">${char}</span>`;
          } else {
            lineHtml += char;
          }
        }

        html += `<span class="line">${lineHtml}</span>`;

      });

      elm.innerHTML = html;

      ScrollTrigger.create({
        toggleActions: 'play pause resume reset',
        trigger: elm,
        start: `top bottom`,
        onEnter: function () {
          elm.classList.remove('init');
        },
        onLeaveBack: function () {
          elm.classList.add('init');
        },
      });
    });

    function splitHTML(html) {
      const result = [];
      const parts = html.match(/<[^>]+>|&[a-zA-Z0-9#]+;|[^<&]+/g) || [];

      for (const part of parts) {
        if (part.startsWith('<')) {
          result.push(part);
        } else if (part.startsWith('&') && part.endsWith(';')) {
          result.push(part);
        } else {
          result.push(...part.split(''));
        }
      }

      return result;
    }
  }


  // --- モックエフェクト（ABOUT）------
  try {

    if (document.querySelector('.js-mock-pageTitle')) {
      document.querySelectorAll('.js-mock-pageTitle').forEach(wrapper => {
        const fixedBox = wrapper.querySelector('.js-mock-pageTitle-fixed');
        wrapper.style.height = `${wrapper.clientHeight}px`;

        const pageTitleTop = wrapper.getBoundingClientRect().top;

        fixedBox.style.top = `${pageTitleTop}px`;
        fixedBox.classList.add('is-fixed');

        ScrollTrigger.create({
          toggleActions: 'play pause resume reset',
          trigger: wrapper,
          start: 'bottom top',
          onEnter: function () {
            fixedBox.classList.add('is-hide');
          },
          onLeaveBack: function () {
            fixedBox.classList.remove('is-hide');
          },
        });

      })
    }

    if (document.querySelector('.js-mock .js-mock-image')) {
      document.querySelectorAll('.js-mock .js-mock-image').forEach(elm => {
        const wrapper = elm.closest('.js-mock');
        ScrollTrigger.create({
          trigger: wrapper,
          start: 'top top',
          end: 'bottom top',
          pin: elm,
          scrub: true,
        });
      })
    }


  } catch (err) {
    console.error(err);
  }



});

